export default __webpack_public_path__ + "static/media/menu-2.a938345b.svg";